module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Confirm 确认框")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.confirm()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("this.$confirm({\n      caption: 'confirm Title',   // 确认框Title（可不填）\n      content: 'confirm Content',       // 内容\n  }).then(() => {    // 使用了Promise语法糖, 点击确定后可以触发回调\n    // 确认的回调\n  }).catch(() => {\n    // 取消的回调\n  })")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d211a05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pluginsDemo/confirm.vue
// module id = 405
// module chunks = 1